import { APPLICATION_NAMES } from "../constants";
import http from "./HttpService";

const endpoint = `/lookup/`;
const eventEndPoint = `/lookup/event/`;
const partnerEndPoint = `/lookup/partnership/`;
const citizenScience = `/lookup/citizen/science/`;
const vsEndpoint = `/lookup/volunteer/scientist/`;

const getTitles = async () => {
  const response = await http.get(`${endpoint}titles`);
  return response;
};

const getRaces = async (targetModule = APPLICATION_NAMES.EVENTS_APP) => {
  const response = await http.get(`${endpoint}races?targetModule=${targetModule}`);
  return response;
};

const getGenders = async (targetModule = APPLICATION_NAMES.EVENTS_APP) => {
  const response = await http.get(`${endpoint}genders?targetModule=${targetModule}`);
  return response;
};

const getProvinces = async () => {
  const response = await http.get(`${endpoint}south-africa/provinces`);
  return response;
};

const getProvincesDistrictTowns = async () => {
  const response = await http.get(`${endpoint}south-africa/province-district-towns`);
  return response;
};

const getProvincesDistrict = async () => {
  const response = await http.get(`${endpoint}south-africa/provinces-districts`);
  return response;
};

const getVenueTypes = async () => {
  const response = await http.get(`${endpoint}event/venue/types`);
  return response;
};

const getEventTypes = async () => {
  const response = await http.get(`${endpoint}event/types`);
  return response;
};

const getEventStatus = async () => {
  const response = await http.get(`${eventEndPoint}status`);
  return response;
};

const getEventGroups = async (all=false) => {
  const response = await http.get(`${endpoint}event/groups?all=${all}`);
  return response;
};

const getTargetParticipants = async () => {
  const response = await http.get(`${eventEndPoint}participant/types`);
  return response;
};

const getEventObjectives = async () => {
  const response = await http.get(`${eventEndPoint}objectives`);
  return response;
};

const getOrganiserExperience = async () => {
  const response = await http.get(`${eventEndPoint}organiser/experience`);
  return response;
};

const getDisability = async () => {
  const response = await http.get(`${eventEndPoint}participant/disabilities`);
  return response;
};
const getFaqModule = async () => {
  const response = await http.get(`${endpoint}system-modules`);
  return response;
};

const getLanguages = async () => {
  const response = await http.get(`${endpoint}south-africa/languages`);
  return response;
};

const getProvincesDistricts = async () => {
  const response = await http.get(
    `${endpoint}south-africa/provinces-districts`
  );
  return response;
};

const getParticipantTypes = async () => {
  const response = await http.get(`${eventEndPoint}participant/types`);
  return response;
};

const getLocalityTypes = async () => {
  const response = await http.get(`${partnerEndPoint}locality`);
  return response;
};

const getAgeGroup = async () => {
  const response = await http.get(`${eventEndPoint}participant/age-groups`);
  return response;
};

const getParticipantsMotivations = async () => {
  const response = await http.get(`${citizenScience}participant-motivations`);
  return response;
};

const getScienceFields = async () => {
  const response = await http.get(`${citizenScience}fields`);
  return response;
};

const getScienceDomains = async (fieldId) => {
  const response = await http.get(`${citizenScience}domains/${fieldId}`);
  return response;
};

export const getQualifications = async (targetModule = APPLICATION_NAMES.EVENTS_APP) => {
  const { data } = await http.get(`${vsEndpoint}qualifications?targetModule=${targetModule}`);
  return data;
};

export const getPostMetricQualifications = async (targetModule = APPLICATION_NAMES.EVENTS_APP) => {
  const response = await http.get(`${endpoint}post-metric/qualifications?targetModule=${targetModule}`);
  return response;
};

export const getOccupations = async () => {
  const { data } = await http.get(`${vsEndpoint}occupation`);
  return data;
};

export const getEmploymentSectors = async () => {
  const { data } = await http.get(`${vsEndpoint}employment-sector`);
  return data;
};

export const getVolunteerRoles = async () => {
  const { data } = await http.get(`${vsEndpoint}roles`);
  return data;
};

export const getVolunteerMotivations = async () => {
  const { data } = await http.get(`${vsEndpoint}motivations`);
  return data;
};

export const getEmploymentStatus = async () => {
  const { data } = await http.get(`${vsEndpoint}employment-status`);
  return data;
};

export const getParticipantOccupations = async () => {
  const response = await http.get(`${eventEndPoint}participant/occupations`);
  return response;
};

export const getParticipantSectors = async () => {
  const response = await http.get(`${eventEndPoint}participant/sectors`);
  return response;
};

export const getParticipantRoles = async () => {
  const response = await http.get(`${eventEndPoint}participant/roles`);
  return response;
};

export const getParticipantMotivations = async () => {
  const response = await http.get(`${eventEndPoint}participant/motivations`);
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getTitles,
  getRaces,
  getGenders,
  getDisability,
  getProvinces,
  getEventStatus,
  getEventTypes,
  getEventGroups,
  getVenueTypes,
  getProvincesDistrict,
  getTargetParticipants,
  getEventObjectives,
  getOrganiserExperience,
  getAgeGroup,
  getLanguges: getLanguages,
  getFaqModule,
  getProvincesDistrictTowns,
  getProvincesDistricts,
  getParticipantTypes,
  getLocalityTypes,
  getParticipantsMotivations,
  getScienceFields,
  getScienceDomains,
  getVolunteerRoles,
  getVolunteerMotivations,
  getPostMetricQualifications,
  getParticipantOccupations,
  getParticipantSectors,
  getParticipantRoles,
  getParticipantMotivations,
  getEmploymentSectors,
  getEmploymentStatus
};
